import type { ILoggedUser } from "@/entities/auth/types.ts"
import { requestAuth } from "@/shared/utils/axios.ts"

export async function fetchMe() {
  const { data } = await requestAuth("/user/profile/")
  return data as ILoggedUser
}
